module.exports = __webpack_public_path__ + "assets/img/banner.03c98030.jpg";